import { useState } from 'react';
import { WHATSAPP_CHAT_URL } from '../../../config/contactLinks';

const faqs = [
  { q: 'Hangi bölgelere hizmet veriyorsunuz?', a: 'NiğPak Temizlik olarak Niğde Merkez ve çevresinde hizmet veriyoruz. İlçeler için bizimle iletişime geçin, size özel çözüm sunabiliriz.' },
  { q: 'Temizlik personeli güvenilir mi?', a: 'Tüm personelimiz güvenlik kontrolünden geçmiş, deneyimli ve eğitimli bireylerden oluşmaktadır. Ekibimiz ayrıca sigortalıdır.' },
  { q: 'Fiyatlar nasıl belirleniyor?', a: 'Fiyatlarımız temizlik alanının büyüklüğü, türü ve sıklığına göre belirlenmektedir. Ücretsiz keşif için WhatsApp\'tan bize ulaşabilirsiniz.' },
  { q: 'Malzeme ve ekipmanları siz mi getiriyorsunuz?', a: 'Evet, tüm profesyonel ekipman ve ürünleri biz sağlıyoruz. Çevre dostu ve sağlıklı ürünler kullanıyoruz.' },
  { q: 'İnşaat sonrası temizlik ne kadar sürer?', a: 'Binanın büyüklüğüne göre değişir. Ortalama bir daire için 4-6 saat, villa için 8-12 saat. Kesin süre için ücretsiz keşif yapıyoruz.' },
  { q: 'Koltuk ve halı yıkama nasıl yapılıyor?', a: 'Profesyonel buhar ve ekstraksiyon makinelerimizle derin temizlik yapılır. İşlem sonrası 4-6 saat kuruma süresi gerekir.' },
  { q: 'Aylık kontrat mümkün mü?', a: 'Evet! Apartman, ofis ve mağaza için haftalık/aylık kontratlarımız mevcuttur. Kontrat müşterilerimize özel fiyat ve öncelikli randevu sunuyoruz.' },
  { q: 'Randevu nasıl alınır?', a: 'WhatsApp (0543 191 0851) veya iletişim formumuz aracılığıyla randevu alabilirsiniz. 2 saat içinde geri dönüş garantisi veriyoruz.' },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section id="sss" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="mb-14">
          <p className="text-gold text-xs font-bold uppercase tracking-[0.25em] mb-3">SSS</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-navy tracking-tight">
            Sık Sorulan Sorular
          </h2>
        </div>

        {/* Accordion */}
        <div className="flex flex-col divide-y divide-gray-100">
          {faqs.map((faq, idx) => (
            <div key={idx} className="py-5">
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 text-left cursor-pointer group"
              >
                <span className={`font-bold text-sm transition-colors ${openIdx === idx ? 'text-gold' : 'text-navy group-hover:text-gold'}`}>
                  {faq.q}
                </span>
                <span className={`w-7 h-7 flex items-center justify-center rounded-lg shrink-0 transition-all ${openIdx === idx ? 'bg-gold text-white' : 'bg-[#f7f8fc] text-navy'}`}>
                  <i className={`${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                </span>
              </button>
              {openIdx === idx && (
                <p className="text-gray-400 text-sm leading-[1.9] mt-4 pr-12">{faq.a}</p>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 bg-[#f7f8fc] rounded-2xl p-7 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <p className="font-bold text-navy text-sm mb-1">Sorunuz burada yoksa?</p>
            <p className="text-gray-400 text-xs">WhatsApp üzerinden bize doğrudan yazabilirsiniz.</p>
          </div>
          <a href={WHATSAPP_CHAT_URL} target="_blank" rel="nofollow noreferrer"
            className="flex items-center gap-2 bg-navy hover:bg-navy-dark text-white font-bold px-6 py-3 rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-whatsapp-line text-base"></i>
            WhatsApp ile Sorun
          </a>
        </div>
      </div>
    </section>
  );
}
